export default "__VITE_ASSET__DgB5jRbg__"